export default __webpack_public_path__ + "static/media/bigSprinter.448428da.jpg";